<template>
  <div class="container-fluid mt-3">
    <HeaderLevelEmployee @importData="handleImportData" :loadingImport="loadingImport" />
    <!-- FILTER -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="row">

          <div class="col-md-3 mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Mã, tên, SĐT"
              v-model="filters.keyword"
            >
          </div>
          <div>
            <button
              class="btn btn-primary mr-2"
              @click="searchList"
            >
              Tìm kiếm
            </button>


          </div>

        </div>

      </div>
      <div class="p-6">
        <div class="card example-preview table-responsive overflow-auto mt-3">
          <table class="main-table">
            <colgroup>
              <col class="col-name">
              <col class="col-phone">
              <col class="col-level">
              <col class="col-action">
              <col class="col-detail">
            </colgroup>
            <thead>
            <tr>
              <th class="sortable" @click="sortBy('name')">
                Nhân sự
              </th>
              <th>Số điện thoại</th>
              <th>Vị trí</th>
              <th>Hành động</th>
              <th>Chi tiết</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="pagedData.length === 0" class="empty-row">
              <td colspan="5">Không có dữ liệu phù hợp</td>
            </tr>
            <template v-for="row in pagedData">
              <tr>
                <td>
                  <div class="name-cell">
                    <span class="name-text">{{ row.name.trim() }} - {{ row.id + 100000 }}</span>
                  </div>
                </td>
                <td>
                  <span v-if="row.phone" >{{ row.phone }}</span>
                  <span v-else class="no-phone">Chưa có</span>
                </td>
                <td>
                  {{ row.profile && row.profile.account_type ? row.profile.account_type.name : '—' }}
                </td>
                <td>
                  <button class="btn btn-success" @click="openCreateCriteria(row)">+ Thêm mới tiêu chí</button>
                </td>
                <td>
                  <button class="btn btn-xs btn-icon btn-outline-success"
                          :class="{ active: expanded.includes(row.id) }"
                          :disabled="row.criterias.length === 0"
                          @click="toggleExpand(row.id)"
                          title="Xem chi tiết">
                    <i class="far fa-eye"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="expanded.includes(row.id)" class="sub-row">
                <td colspan="5">
                  <div class="sub-scroll-wrap">
                    <table class="sub-table">
                      <thead>
                      <tr>
                        <th class="sticky-left" style="min-width:160px;">Tiêu chí</th>
                        <th  style="min-width:90px;">Nhiệm vụ</th>
                        <th  style="min-width:90px;">Loại chỉ số</th>
                        <th
                          v-for="(lv, lvi) in getRowLevels(row)"
                          :class="row.latest_level_approval_request.current_level.id == lv.id ? 'bg-warning' : ''"
                          :key="`head-level-${row.id}-${lv.id || lv.level || lvi}`"
                        >
                          Bậc {{ lv.level }}
                        </th>
                        <th class="sticky-right" style="min-width:100px;">Hành động</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in row.criterias" :key="c.id">
                          <td class="criteria-name sticky-left"> <span :title="c.name">{{ truncateText(c.name) }}</span></td>
                          <td>{{ c.task }}</td>
                        <td>
                          <span :class="c.type === 1 ? 'tag-month' : 'tag-quarter'">
                            {{ c.type === 1 ? 'Tháng' : 'Quý' }}
                          </span>
                        </td>
                        <td v-for="(lv, lvi) in getRowLevels(row)"
                            :key="`score-cell-${c.id}-${lv.id || lv.level || lvi}`"
                            :class="row.latest_level_approval_request.current_level.id == lv.id ? 'bg-warning' : ''"
                            class="score-val">
                          {{ getScoreByLevel(c, lv) }}
                        </td>
                        <td class="sticky-right">
                          <div class="action-row">
                            <button type="button" class="btn btn-xs btn-icon btn-outline-info ml-2" title="Sửa tiêu chí & điểm chuẩn"
                                    @click="openEditCriteria(row, c)">
                              <i class="fas fa-pen-nib"></i>
                            </button>
                            <button type="button" class="btn btn-xs btn-icon btn-outline-danger" title="Xoá điểm chuẩn"
                                    @click="deleteStandard(c.id)">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div class="pagination-wrap">
          <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                    :click-handler="clickCallback"
                    :prev-text="'Trước'" :next-text="'Sau'"
                    :container-class="'pagination b-pagination justify-content-center mt-0 mb-0'"
                    :pageLinkClass="'page-link'"
                    :next-link-class="'next-link-item'"
                    :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
                    :next-class="'page-link'" :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
    <el-dialog
      title="Thêm mới level nhân sự"
      :visible.sync="dialogCreate"
      width="70%"
      @close="resetCreateForm"
    >
      <ValidationObserver v-slot="{ handleSubmit }" ref="createFormObserver">
        <form @submit.prevent="handleSubmit(submitCreate)">
          <div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Mã nhân sự</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.user_id"
                    placeholder="Nhập mã nhân sự"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Họ và tên</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.user_name"
                    placeholder="Nhập họ và tên"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Chức vụ</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.account_name"
                    placeholder="Nhập chức vụ"
                  />
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="font-weight-bold">Chỉ số chính</div>
              <el-button type="primary" size="mini" @click="addCreateItem">
                + Thêm chỉ số
              </el-button>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th style="min-width: 260px">Chỉ số chính</th>
                  <th
                    v-for="(col, colKey) in headerColumns"
                    :key="colKey"
                    style="min-width: 180px"
                  >
                    {{ col.name || colKey }}
                  </th>
                  <th style="min-width: 90px">Xóa</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="createForm.items.length === 0">
                  <td :colspan="2 + headerColumnKeys.length" class="text-center">
                    Chưa có chỉ số. Bấm “Thêm chỉ số” để thêm.
                  </td>
                </tr>
                <tr v-for="(row, rowIndex) in createForm.items" :key="rowIndex">
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="row.key_index"
                      placeholder="Nhập tên chỉ số chính"
                    />
                  </td>
                  <td v-for="colKey in headerColumnKeys" :key="colKey">
                    <input
                      type="text"
                      class="form-control"
                      v-model="row[colKey].value"
                      :placeholder="headerColumns[colKey]?.name || colKey"
                    />
                  </td>
                  <td class="text-center">
                    <button class="btn btn-outline-danger p-0 mr-2"
                            title="Xoá" type="button"
                            @click="removeCreateItem(rowIndex)"><i
                      class="el-icon-delete p-2"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogCreate = false">Hủy</el-button>
            <el-button type="primary" native-type="submit">Thêm mới</el-button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog
      title="Sửa tiêu chí & điểm chuẩn"
      :visible.sync="dialogEditCriteria"
      width="700px"
      @close="resetEditCriteriaForm"
    >
      <ValidationObserver v-slot="{ handleSubmit }" ref="editCriteriaObserver">
        <form @submit.prevent="handleSubmit(saveEditCriteria)">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Tên tiêu chí <span class="text-danger">*</span></label>
                <ValidationProvider name="Tên tiêu chí" rules="required" v-slot="{ errors, classes }">
                  <input
                    type="text"
                    class="form-control"
                    :class="classes"
                    v-model="editCriteriaForm.name"
                    placeholder="Nhập tên tiêu chí"
                  >
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label>Nhiệm vụ <span class="text-danger">*</span></label>
                <ValidationProvider name="Nhiệm vụ" rules="required" v-slot="{ errors, classes }">
                  <input
                    type="text"
                    class="form-control"
                    :class="classes"
                    v-model="editCriteriaForm.task"
                    placeholder="Nhập nhiệm vụ"
                  >
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label>Loại chỉ số <span class="text-danger">*</span></label>
                <ValidationProvider name="Tên tiêu chí" rules="required" v-slot="{ errors, classes }">
                  <el-select class="w-100" v-model="editCriteriaForm.type">
                    <el-option v-for="(item, index) in types" :key="index"
                               :value="item.id"
                               :label="item.value"></el-option>
                  </el-select>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
              <tr>
                <th style="min-width: 160px">Level</th>
                <th style="min-width: 180px">Điểm chuẩn<span class="text-danger">*</span></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(lv, idx) in editCriteriaForm.levels" :key="idx">
                <td>{{ lv.level_label }}</td>
                <td>
                  <ValidationProvider :name="`Điểm chuẩn level ${lv.level_label}`" rules="required"
                                      v-slot="{ errors, classes }">
                    <div class="input-group">
                      <input
                        type="text"
                        inputmode="decimal"
                        class="form-control"
                        v-model="lv.score_standard"
                        placeholder="Điểm chuẩn"
                      >
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>

                    <div class="fv-plugins-message-container">
                      <div class="fv-help-block">
                        {{ errors[0] }}
                      </div>
                    </div>
                  </ValidationProvider>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div slot="footer" class="dialog-footer d-flex justify-content-end">
            <el-button @click="dialogEditCriteria = false">Hủy</el-button>
            <el-button type="primary" :loading="savingEditCriteria" native-type="submit"
                       style="background: #4D44B5 !important; color: white !important; padding: 10px 20px; border-radius: 5px">
              Xác nhận
            </el-button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog
      title="Import tiêu chí teamlead"
      :visible.sync="dialogImportError"
      width="70%"
    >
      <div>Hệ thống phát hiện có lỗi trong quá trình import dữ liệu:</div>
      <div v-if="normalizedImportErrors.length" class="example-preview mt-3">
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-vertical-center b-table">
      <thead>
        <tr>
          <th :class="column.label == 'Lỗi' || column.label == 'Tên chỉ số' ? 'w-300' : ''" style="min-width:100px" v-for="column in importErrorColumns" :key="column.key">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in normalizedImportErrors" :key="rowIndex">
          <td v-for="column in importErrorColumns" :key="`${rowIndex}-${column.key}`">
            <template v-if="Array.isArray(row[column.key])">
              <p
                v-for="(errorItem, errorIndex) in row[column.key]"
                :key="`${rowIndex}-${column.key}-${errorIndex}`"
                class="mb-1 text-danger"
              >
                {{ errorItem }}
              </p>
            </template>
            <template v-else>
              {{ row[column.key] || "—" }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
      <div v-else class="mt-3 text-danger">
        {{ importErrorMessage || "Có lỗi xảy ra trong quá trình import dữ liệu." }}
      </div>
      <div slot="footer" class="dialog-footer d-flex justify-content-end">
        <el-button @click="dialogImportError = false">Đóng</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
  CREATE_TEAMLEAD_CRITERIA_STANDARD,
  DELETE_TEAMLEAD_CRITERIA_STANDARD,
  GET_TEAMLEAD_CRITERIA_STANDARD,
  GET_USER_LEVEL_ALL,
  UPDATE_TEAMLEAD_CRITERIA_STANDARD,
  IMPORT_TEAMLEAD_CRITERIA_STANDARD,
} from "@/core/services/store/level/level.module";
import HeaderLevelEmployee from "@/view/pages/level/components/HeaderLevelEmployee.vue";
import {mapGetters} from "vuex";

export default {
  name: "LevelManagement",
  components: {
    HeaderLevelEmployee,
  },
  computed: {
    ...mapGetters(["currentUser"]),
    filteredData() {
      let d = this.rawData;
      const q = this.search.trim().toLowerCase();
      if (q) {
        d = d.filter(r =>
          r.name.toLowerCase().includes(q) ||
          (r.phone && r.phone.includes(q))
        );
      }
      if (this.filter === 'has') d = d.filter(r => r.criterias.length > 0);
      if (this.filter === 'none') d = d.filter(r => r.criterias.length === 0);
      if (this.sortKey === 'name') {
        d = [...d].sort((a, b) => a.name.localeCompare(b.name, 'vi') * this.sortDir);
      }
      return d;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredData.length / this.pageSize));
    },
    pagedData() {
      const start = (this.page - 1) * this.pageSize;
      return this.filteredData.slice(start, start + this.pageSize);
    },
    normalizedImportErrors() {
      return (this.importErrorRows || []).map((row) => this.normalizeImportErrorRow(row));
    },
    importErrorColumns() {
      const columnKeys = [];

      this.normalizedImportErrors.forEach((row) => {
        Object.keys(row || {}).forEach((key) => {
          if (!columnKeys.includes(key)) {
            columnKeys.push(key);
          }
        });
      });

      return columnKeys.map((key) => ({
        key,
        label: this.getImportErrorColumnLabel(key),
      }));
    }
  },
  data() {
    return {
      dialogCreate: false,
      loadingImport: false,
      createForm: {
        user_id: "",
        user_name: "",
        account_name: "",
        items: []
      },
      filters: {
        keyword: "",
        status: "",
        type: ""
      },
      checkData: true,
      listStatus: [
        {id: 1, value: 'Hoạt động'},
        {id: 0, value: 'Ngừng'},
      ],
      types: [
        {id: 1, value: 'Tháng'},
        {id: 2, value: 'Quý'},
      ],
      listTypeLevel: [
        {id: 1, value: 'aaa'},
        {id: 0, value: 'vbvvvv'},
      ],
      // Đang sửa bản ghi nào (theo index của reports)
      editingIndex: null,
      editReportForm: null,
      levels: [],
      rawData: [],
      expanded: [],
      sortKey: 'name',
      sortDir: 1,
      page: 1,
      last_page: 1,
      pageSize: 20,
      search: '',
      filter: 'all',
      headerColumns: [],
      headerColumnKeys: [],

      dialogEditCriteria: false,
      savingEditCriteria: false,
      dialogImportError: false,
      importErrorMessage: "",
      importErrorRows: [],
      editCriteriaForm: {
        id: null,
        task: null,
        user_id: null,
        name: "",
        type: "",
        levels: [],
      },
      currentLevelId: ''
    }
  },
  mounted() {
    this.getListUserLevel();
    this.getListTeamleadCriteriaStandard();
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý Level", route: "level-employees"},
      {title: "Danh sách Level"},
    ]);
  },
  methods: {
    clickCallback(obj) {
      this.page = obj
      this.getListTeamleadCriteriaStandard();
    },
    getListUserLevel() {
      this.$store
        .dispatch(GET_USER_LEVEL_ALL, this.createForm)
        .then((res) => {
          this.levels = res.data;

        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.savingCreate = false;
        });
    },
    initials(name) {
      const parts = name.trim().split(' ').filter(Boolean);
      if (!parts.length) return '?';
      return parts.length === 1
        ? parts[0][0].toUpperCase()
        : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    },
    sortBy(key) {
      if (this.sortKey === key) this.sortDir *= -1;
      else {
        this.sortKey = key;
        this.sortDir = 1;
      }
    },
    toggleExpand(id) {
      const idx = this.expanded.indexOf(id);
      if (idx === -1) this.expanded.push(id);
      else this.expanded.splice(idx, 1);
    },
    getRowLevels(row) {
      const map = new Map();
      (row?.criterias || []).forEach((c) => {
        (c?.score_standards || []).forEach((s) => {
          const level = s?.level;
          if (!level) return;
          const key = level.id ?? level.level;
          if (!map.has(key)) {
            map.set(key, {
              id: level.id ?? null,
              level: level.level ?? "",
              name: level.name ?? "",
            });
          }
        });
      });
      return Array.from(map.values()).sort((a, b) => Number(a.level) - Number(b.level));
    },
    getScoreByLevel(criteria, level) {
      const found = (criteria?.score_standards || []).find(
        (s) => (s?.level?.id ?? s?.level?.level) === (level?.id ?? level?.level)
      );
      if (!found) return "—";
      const score = found?.score_standard;
      return score === null || score === undefined || score === "" ? "—" : `${score} %`;
    },
    deleteEmployeeRow(id) {
      Swal.fire({
        title: "Bạn chắc chắn muốn xóa?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Không",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.$store
          .dispatch(DELETE_TEAMLEAD_CRITERIA_STANDARD, id)
          .then((res) => {
            if (res?.error) {
              this.$bvToast?.toast?.(res.message || "Có lỗi xảy ra", {
                title: "Xóa",
                variant: "danger",
                solid: true,
              });
              return;
            }
            this.$bvToast?.toast?.(res?.message || "Xóa thành công", {
              title: "Xóa",
              variant: "success",
              solid: true,
            });
            this.getListTeamleadCriteriaStandard();
          })
          .catch((err) => {
            this.$bvToast?.toast?.(err?.data?.message || "Có lỗi xảy ra", {
              title: "Xóa",
              variant: "danger",
              solid: true,
            });
          });
      });
    },
    openEditCriteria(row, c) {
      this.dialogEditCriteria = true;
      this.editCriteriaForm = {
        id: c?.id ?? null,
        task: c?.task ?? '',
        user_id: row?.id ?? null,
        name: c?.name ?? "",
        type: c?.type ?? "",
        levels: (c?.score_standards || []).map((s) => ({
          id: s?.level?.id ?? s?.level_id ?? s?.level?.level,
          level_label: s?.level?.level ?? "",
          score_standard: s?.score_standard ?? "",
        })),
      };
    },
    resetEditCriteriaForm() {
      this.editCriteriaForm = {
        id: null,
        user_id: null,
        task: "",
        type: "",
        name: "",
        levels: [],
      };
      this.savingEditCriteria = false;
    },
    openCreateCriteria(row) {
      this.dialogEditCriteria = true;
      this.editCriteriaForm = {
        id: null,
        user_id: row?.id ?? null,
        name: "",
        task: "",
        type: "",
        levels: (this.levels || []).map((lv) => ({
          id: lv.id,
          level_label: lv.level,
          score_standard: "",
        })),
      };
    },
    saveEditCriteria() {
      this.savingEditCriteria = true;
      const isCreate = !this.editCriteriaForm?.id;
      const payload = {
        name: this.editCriteriaForm.name,
        task: this.editCriteriaForm.task,
        type: this.editCriteriaForm.type,
        user_id: this.editCriteriaForm.user_id,
        levels: (this.editCriteriaForm.levels || []).map((lv) => ({
          id: lv.id,
          score_standard: lv.score_standard,
        })),
      };
      if (!isCreate) {
        payload.id = this.editCriteriaForm.id;
      }

      const action = isCreate ? CREATE_TEAMLEAD_CRITERIA_STANDARD : UPDATE_TEAMLEAD_CRITERIA_STANDARD;

      this.$store
        .dispatch(action, payload)
        .then(() => {
          this.dialogEditCriteria = false;
          this.getListTeamleadCriteriaStandard();
          if (isCreate) {
            this.$bvToast?.toast?.("Thêm mới thành công", {
              title: "Thêm mới",
              variant: "success",
              solid: true,
            });
            return;
          }
          this.$bvToast?.toast?.("Cập nhật thành công", {
            title: "Sửa",
            variant: "success",
            solid: true,
          });

        })
        .catch((err) => {
          this.$bvToast?.toast?.(err?.data?.message || "Có lỗi xảy ra", {
            title: "Có lỗi xảy ra",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.savingEditCriteria = false;
        });
    },
    deleteStandard(id) {
      Swal.fire({
        title: "Bạn chắc chắn muốn xóa?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Không",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.$store
          .dispatch(DELETE_TEAMLEAD_CRITERIA_STANDARD, id)
          .then(() => {
            this.$bvToast?.toast?.("Xóa thành công", {
              title: "Xóa",
              variant: "success",
              solid: true,
            });
            this.getListTeamleadCriteriaStandard();
          })
          .catch((err) => {
            this.$bvToast?.toast?.(err?.data?.message || "Có lỗi xảy ra", {
              title: "Xóa",
              variant: "danger",
              solid: true,
            });
          });
      });
    },
    getListTeamleadCriteriaStandard() {
      this.$store
        .dispatch(GET_TEAMLEAD_CRITERIA_STANDARD, this.filters)
        .then((res) => {
          this.rawData = res.data.data;
          this.last_page = res.data.last_page;
          const current = this.rawData.find(item => item.id == this.currentUser.user.id);
          this.currentLevelId = current && current.latest_level_approval_request && current.latest_level_approval_request.current_level ?
          current.latest_level_approval_request.current_level.id :
          '';
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.savingCreate = false;
        });
      console.log(this.reports, 'this.header')
    },
    searchList() {
      this.getListTeamleadCriteriaStandard();
    },

    startReportEdit(reportIndex) {
      const report = this.reports[reportIndex]
      if (!report) return

      this.editingIndex = reportIndex
      // clone sâu để chỉnh độc lập rồi lưu lại một lần
      this.editReportForm = JSON.parse(JSON.stringify(report))
    },

    cancelReportEdit() {
      this.editingIndex = null
      this.editReportForm = null
    },

    saveReport(reportIndex) {
      if (!this.editReportForm) return

      this.$set(this.reports, reportIndex, this.editReportForm)
      this.cancelReportEdit()
    },
    openCreate() {
      this.dialogCreate = true;
      this.initCreateForm();
    },

    initCreateForm() {
      // đảm bảo có header để tạo các cột phía sau (ju_1, ju_2, ...)
      if (!this.header || Array.isArray(this.header) && this.header.length === 0) {
        this.test();
      }

      this.createForm = {
        user_id: "",
        user_name: "",
        account_name: "",
        items: []
      };
    },

    resetCreateForm() {
      this.createForm = {
        user_id: "",
        user_name: "",
        account_name: "",
        items: []
      };
    },

    addCreateItem() {
      const row = {key_index: ""};
      this.headerColumnKeys.forEach((key) => {
        row[key] = {
          id: this.headerColumns[key]?.id ?? 1,
          name: this.headerColumns[key]?.name ?? key,
          value: ""
        };
      });
      this.createForm.items.push(row);
    },

    removeCreateItem(rowIndex) {
      this.createForm.items.splice(rowIndex, 1);
    },

    submitCreate() {
      const newReport = JSON.parse(JSON.stringify(this.createForm));
      this.dialogCreate = false;
      this.resetCreateForm();
    },
    truncateText(text, maxLength = 40) {
      if (!text) return '';
      return text.length > maxLength
        ? text.slice(0, maxLength) + '...'
        : text;
    },
    handleImportData(data) {
      this.loadingImport = true;
      this.$store
        .dispatch(IMPORT_TEAMLEAD_CRITERIA_STANDARD, data)
        .then((res) => {
          const message = this.getImportMessage(res);
          const importErrorRows = this.getImportErrorRows(res);

          if (this.isImportErrorMessage(message) || importErrorRows.length) {
            this.openImportErrorDialog(res);
            this.loadingImport = false;
            this.$bvToast?.toast?.("Import thất bại", {
              title: "Import",
              variant: "danger",
              solid: true,
            });
            return;
          }

          this.$bvToast?.toast?.(message || "Import thành công", {
            title: "Import thành công",
            variant: "success",
            solid: true,
          });
          this.getListTeamleadCriteriaStandard();
          this.loadingImport = false;
        })
        .catch((e) => {
          this.$bvToast?.toast?.(e?.data?.message || "Có lỗi xảy ra", {
            title: "Import",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.savingCreate = false;
        });
    },
    getImportMessage(payload) {
      return payload?.message || payload?.data?.message || "";
    },
    isImportErrorMessage(message) {
      const normalizedMessage = String(message || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      return normalizedMessage.includes("data loi");
    },
    getImportErrorRows(payload) {
      const directErrors = payload?.dataError || payload?.data?.dataError || payload?.errors || payload?.data?.errors;
      if (Array.isArray(directErrors) && directErrors.length) {
        return directErrors;
      }

      const rows = payload?.data;
      if (!Array.isArray(rows) || !rows.length) {
        return [];
      }

      const rowsWithError = rows.filter((row) => {
        if (!row || typeof row !== "object") {
          return false;
        }
        return !!row.error || !!row.errors || !!row.message;
      });

      if (rowsWithError.length) {
        return rowsWithError;
      }

      if (this.isImportErrorMessage(this.getImportMessage(payload))) {
        return rows;
      }

      return [];
    },
    openImportErrorDialog(payload) {
      this.importErrorMessage = this.getImportMessage(payload);
      this.importErrorRows = this.getImportErrorRows(payload);
      this.dialogImportError = true;
    },
    normalizeImportErrorRow(row) {
      if (!row || typeof row !== "object" || Array.isArray(row)) {
        return {error: [String(row || "Có lỗi xảy ra")]};
      }

      const normalizedRow = {};
      Object.keys(row).forEach((key) => {
        const value = row[key];

        if (Array.isArray(value)) {
          normalizedRow[key] = value.map((item) => this.stringifyImportErrorValue(item));
          return;
        }

        normalizedRow[key] = this.stringifyImportErrorValue(value);
      });

      return normalizedRow;
    },
    stringifyImportErrorValue(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }
      if (typeof value === "object") {
        return JSON.stringify(value);
      }
      return String(value);
    },
    getImportErrorColumnLabel(key) {
      const labelMap = {
        row: "Dòng",
        line: "Dòng",
        stt: "STT",
        ma_nhan_su: "Mã nhân sự",
        nhan_su: "Nhân sự",
        user_id: "Mã nhân sự",
        user_name: "Nhân sự",
        nhiem_vu: "Nhiệm vụ",
        task: "Nhiệm vụ",
        loai_chi_so: "Loại chỉ số",
        type: "Loại chỉ số",
        ten_chi_so: "Tên chỉ số",
        name: "Tên chỉ số",
        error: "Lỗi",
        errors: "Lỗi",
        message: "Lỗi",
      };

      if (labelMap[key]) {
        return labelMap[key];
      }

      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    }
  },
  getLable(key)
  {
    return this.importErrorColumns.find(column => column.key === key)?.label;
  }

}
</script>
<style>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: 'Segoe UI', sans-serif;
  background: #f4f6fb;
  color: #222;
  font-size: 14px;
}

/* ===== CARD ===== */
.card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

/* ===== OUTER TABLE ===== */
.outer-table-wrap {
  overflow-x: auto;
}

table.main-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

table.main-table col.col-name   { width: 28%; }
table.main-table col.col-phone  { width: 18%; }
table.main-table col.col-level  { width: 16%; }
table.main-table col.col-action { width: 24%; }
table.main-table col.col-detail { width: 14%; }

table.main-table thead th {
  background: #f9fafb;
  padding: 11px 14px;
  font-weight: 600;
  font-size: 13px;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
  text-align: left;
}

table.main-table thead th.sortable {
  cursor: pointer;
  user-select: none;
}
table.main-table thead th.sortable:hover { color: #374151; }

table.main-table tbody td {
  padding: 11px 14px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

table.main-table tbody tr:last-child td { border-bottom: none; }
table.main-table tbody tr:not(.sub-row):hover { background: #fafafa; }

/* ===== AVATAR ===== */
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ede9fe;
  color: #5b21b6;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
}
.name-cell { display: flex; align-items: center; }
.name-text { font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.phone-text { color: #6b7280; font-size: 13px; }
.no-phone { color: #9ca3af; font-style: italic; font-size: 12px; }

/* ===== BADGES ===== */
.badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 500;
}
.badge-purple { background: #ede9fe; color: #5b21b6; }
.badge-blue   { background: #dbeafe; color: #1d4ed8; }
.badge-green  { background: #dcfce7; color: #15803d; }
.badge-amber  { background: #fef9c3; color: #92400e; }

.sub-row > td {
  padding: 0 !important;
  background: #f8faff;
}

/*
  overflow-x: auto tạo scroll context riêng biệt.
  Scroll này KHÔNG lan ra ngoài table cha.
*/
.sub-scroll-wrap {
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  border-top: 2px solid #818cf8;
  border-bottom: 1px solid #e5e7eb;
}

/* Scrollbar đẹp hơn */
.sub-scroll-wrap::-webkit-scrollbar { height: 6px; }
.sub-scroll-wrap::-webkit-scrollbar-track { background: #f1f1f1; }
.sub-scroll-wrap::-webkit-scrollbar-thumb { background: #c7d2fe; border-radius: 99px; }
.sub-scroll-wrap::-webkit-scrollbar-thumb:hover { background: #818cf8; }

table.sub-table {
  border-collapse: collapse;
  /*
    KHÔNG set width: 100% ở đây.
    Để table tự rộng theo nội dung (max-content).
    Kết hợp với white-space: nowrap bên dưới → tạo ra nội dung
    rộng hơn container → overflow-x: auto của wrap hoạt động.
  */
  white-space: nowrap;
}

table.sub-table th {
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #f0f4ff;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
}

table.sub-table td {
  padding: 9px 14px;
  border: 1px solid #f0f0f0;
  font-size: 13px;
  background: #fff;
}

table.sub-table tbody tr:hover td { background: #f9f9ff; }

.score-val { font-weight: 600; }
.criteria-name { font-weight: 600; color: #1d4ed8; }

.tag-month   { background: #dcfce7; color: #166534; padding: 2px 8px; border-radius: 99px; font-size: 11px; }
.tag-quarter { background: #fef9c3; color: #92400e; padding: 2px 8px; border-radius: 99px; font-size: 11px; }

/* ===== STICKY COLUMNS trong sub-table ===== */
.sticky-left {
  position: sticky;
  left: 0;
  z-index: 3;
}
table.sub-table th.sticky-left {
  background: #e8eeff;
  border-right: 2px solid #c7d2fe !important;
}
table.sub-table td.sticky-left {
  background: #f4f6ff;
  border-right: 2px solid #c7d2fe !important;
}

.sticky-right {
  position: sticky;
  right: 0;
  z-index: 3;
}
table.sub-table th.sticky-right {
  background: #e8eeff;
  border-left: 2px solid #c7d2fe !important;
}
table.sub-table td.sticky-right {
  background: #f4f6ff;
  border-left: 2px solid #c7d2fe !important;
}

.action-row { display: flex; gap: 6px; align-items: center; }

/* ===== PAGINATION ===== */
.pagination-wrap {
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}
.w-300 {
  min-width: 300px !important;
}
.page-btn {
  padding: 5px 12px;
  border-radius: 7px;
  border: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
}
.page-btn:hover { background: #f3f4f6; }
.page-btn.active { background: #6d28d9; color: #fff; border-color: #6d28d9; }
.page-btn:disabled { opacity: 0.4; cursor: not-allowed; }

/* ===== EMPTY ===== */
.empty-row td { text-align: center; color: #9ca3af; padding: 40px 0; font-style: italic; }
</style>
